import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table table-striped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Importo lordo",
            text: "Importo lordo"
          })
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "% iva",
            text: "% iva"
          }),
          _cache[3] || (_cache[3] = _createTextVNode(" (0 - 100) "))
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.grossAmount) = $event))
          }, null, 512), [
            [_vModelText, _ctx.localValue.grossAmount]
          ]),
          _createElementVNode("div", null, " Importo netto: " + _toDisplayString(_ctx.$filters.currency(_ctx.ivaAmount)), 1)
        ]),
        _createElementVNode("td", null, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.vatPerc) = $event))
          }, null, 512), [
            [_vModelText, _ctx.localValue.vatPerc]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1))
        ]),
        _createElementVNode("td", null, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "form-group" }, "Valuta", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.symbol) = $event))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("option", null, "AuraCoin", -1),
            _createElementVNode("option", null, "€", -1)
          ]), 512), [
            [_vModelSelect, _ctx.localValue.symbol]
          ])
        ])
      ])
    ])
  ]))
}